import { RcFile } from 'antd/lib/upload';
import { Declaration } from 'store/declarations/declaration';
import { JobResponse } from 'store/jobs/job';
import { TransportType } from 'utils/transportTypes';

export enum BrokerUploadSteps {
    MANIFEST = 'manifest',
    JOB = 'job',
    CUSTOMER = 'customer',
    FORM_TYPE = 'formType',
    DECLARATION = 'declaration',
    TEMPLATE = 'template',
    INVOICE = 'invoice',
    BULK_UPLOAD = 'bulkUpload',
}

export type BrokerUploadFormFields = {
    manifest: { manifestId: string };
    job: { jobId: string };
    customer: { customerId: string };
    formType: { formType: string; entryTransportType: TransportType | null };
    declaration: { declarationId: string; mrn: string };
    template: { templateId: string | null };
    invoice: { invoiceFile: RcFile | null };
    bulkUpload: { s3Link: string | null; file: File | null };
};

export type BrokerUploadLocationState = {
    job?: JobResponse;
    declaration?: Declaration;
    jobLocked?: boolean;
    manifestId?: string;
    multipleEnsConfirmed?: boolean;
};

export type BrokerUploadInitOptions = {
    preSelectedJobId?: string;
    preSelectedManifestId?: string;
    preSelectedFormType?: string;
    preSelectedTemplateId?: string;
};

export const createBrokerUploadInitialValues = (options: BrokerUploadInitOptions = {}): BrokerUploadFormFields => ({
    [BrokerUploadSteps.MANIFEST]: { manifestId: options.preSelectedManifestId ?? '' },
    [BrokerUploadSteps.JOB]: { jobId: options.preSelectedJobId ?? '' },
    [BrokerUploadSteps.CUSTOMER]: { customerId: '' },
    [BrokerUploadSteps.FORM_TYPE]: { formType: options.preSelectedFormType ?? '', entryTransportType: null },
    [BrokerUploadSteps.DECLARATION]: { declarationId: '', mrn: '' },
    [BrokerUploadSteps.TEMPLATE]: { templateId: options.preSelectedTemplateId ?? null },
    [BrokerUploadSteps.INVOICE]: { invoiceFile: null },
    [BrokerUploadSteps.BULK_UPLOAD]: { s3Link: null, file: null },
});
